import PropTypes from 'prop-types';
import React from 'react';

const defaultContextValue = {
  data: typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('appContext')) || { currentClass: null } : { currentClass: null },
  set: () => {},
};

const { Provider, Consumer } = React.createContext(defaultContextValue);

const ContextProviderComponent = ({ children }) => {
  const [data, setData] = React.useState(defaultContextValue.data);

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('appContext', JSON.stringify(data));
    }
  }, [data]);

  const addData = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  const state = {
    data,
    set: addData,
  };

  return <Provider value={state}>{children}</Provider>;
};

ContextProviderComponent.propTypes = {
  children: PropTypes.any.isRequired,
};

const withContext = (Component) => (props) => (
  <Consumer>
    {(data) => <Component {...props} context={data} />}
  </Consumer>
);

export {
  Consumer as default,
  ContextProviderComponent,
  withContext,
};
